import CdgUniqGroupFilter from './cdg-uniq-group/cdg.uniq.group.filter';
import EnumReplace from './enum-replace/enum.replace.filter';

const moduleName = 'app.massia.filters';

angular.module(moduleName, []).filter('CdgUniqGroup', CdgUniqGroupFilter).filter('EnumReplace', EnumReplace);

export default moduleName;
